import * as React from 'react';
import { grey600, grey200 } from 'material-ui/styles/colors';
var style = {
    textAlign: 'left',
    borderRadius: '3px',
    color: grey600,
    padding: '.25rem',
    marginBottom: '.5rem',
    backgroundColor: grey200
};
var TimeOverviewHeader = function (_a) {
    var totalHours = _a.totalHours;
    if (!totalHours) {
        return null;
    }
    return (React.createElement("div", { style: style },
        totalHours.toFixed(1),
        " \u00F3ra"));
};
export default TimeOverviewHeader;



//////////////////
// WEBPACK FOOTER
// ./src/pages/timeoverview/TimeOverviewHeader.tsx
// module id = 787
// module chunks = 0